import { render, staticRenderFns } from "./infoModule.vue?vue&type=template&id=470ed58c"
import script from "./infoModule.vue?vue&type=script&lang=js"
export * from "./infoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports